module.exports = __webpack_public_path__ + "static/PG_240619_119-7266272c4aa2d1c55235b4341385d391.jpg";